import React from 'react';

export default function TicketIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-ticket"><g><path className="secondary" d="M22 15v4a1 1 0 0 1-1 1H9V4h12a1 1 0 0 1 1 1v4a3 3 0 0 0 0 6z"/><path className="primary" d="M9 20H3a1 1 0 0 1-1-1v-4a3 3 0 0 0 0-6V5a1 1 0 0 1 1-1h6v16z"/></g></svg>
    </Tag>
  )
};
